import { useQuery } from '@tanstack/react-query';

import { unwrap } from '@/api/envelope';
import { readBilling } from '@/api/generated';

import { billingKey } from './keys';

/**
 * The shared read of the commercial record. Account uses the same key, so
 * opening one page after the other costs a single request.
 */
export function useBilling() {
  return useQuery({
    queryKey: billingKey,
    queryFn: async () => {
      const reply = await readBilling({ throwOnError: true });
      return unwrap(reply.data);
    },
  });
}
